export default __webpack_public_path__ + "static/media/40206.2bc02082.jpg";